import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { searchPage } from '@backstage/plugin-search/alpha';
import { SearchContextProvider } from '@backstage/plugin-search-react';

/**
 * Overrides the native page:search extension with the custom search page.
 *
 * - noHeader: true  → suppresses the PluginHeader so the classic Backstage
 *   Page/Header components (inside SearchPage) are the only visible header.
 * - SearchContextProvider  → supplies the search context required by useSearch(),
 *   SearchBar, SearchFilter, SearchResult, etc.
 * - showCounts: true (in SearchPage.tsx)  → preserves the "N results" count that
 *   was introduced with the native search page.
 */
export const searchModule = createFrontendModule({
    pluginId: 'search',
    extensions: [
        searchPage.override({
            params: {
                noHeader: true,
                loader: async () => {
                    const { SearchPage } = await import('../components/search/SearchPage');
                    return (
                        <SearchContextProvider>
                            <SearchPage />
                        </SearchContextProvider>
                    );
                },
            },
        }),
    ],
});

